import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';
import { Subject, Observable } from 'rxjs';
import { ResponseModel } from '../common/models/responseModel';
import { configJSON } from '../appConfig';
import { HttpClient } from '@angular/common/http';
import { ResponseMessageType } from '../common/enum';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  public subject = new Subject<any>();
  public refreshTokenSubject = new Subject<any>();

  public idleTimeSubject = new Subject<any>();

  constructor(
    private authService: AuthService,
    private router: Router,
    private http: HttpClient,
  ) {}
  timerRefresh() {
    this.idleTimeSubject.next({ isTimerToBeRefreshed: true });
  }
  getTimerRefreshMessage(): Observable<any> {
    return this.idleTimeSubject.asObservable();
  }
  tokenRefreshed() {
    this.refreshTokenSubject.next({ isTokenRefreshed: true });
  }
  getRefreshTokenMessage(): Observable<any> {
    return this.refreshTokenSubject.asObservable();
  }
  checkTokenValidity() {
    if (this.router.url.indexOf('login') !== -1) {
      return;
    }
    this.timerRefresh();
  }

  getRefreshedToken(): Observable<ResponseModel> {
    return this.http.post<ResponseModel>(configJSON.refreshToken, {} ,{withCredentials: true});
  }

  refreshToken() {
    const expiration = this.authService.getExpirationTime();
    if (expiration && new Date(`${expiration} +0000`) <= new Date()) {
      this.authService.logout();
      return;
    }
    this.getRefreshedToken().subscribe({
      next: (result) => {
        if (result && result.message === ResponseMessageType.SUCCESS) {
          this.authService.updateRefreshToken(result.data);
          this.tokenRefreshed();
        } else {
          this.authService.logout();
        }
      },
      error: () => {
        this.authService.logout();
      }
    });
  }
}
